
import { Vue, Component, Prop } from 'vue-property-decorator'

import CustomWrapper from '@/components/CustomWrapper.vue'

const config = {
  name: 'c-video-card-thumbnail',
  components: { CustomWrapper }
}

@Component(config)
export default class CVideoCardThumbnail extends Vue {

  @Prop({ type: String, default: 'div' }) tag!: string

}
